import React from "react";
import "../../styles/Partnership/Partnership.css";

const Partnerships = () => {
  const partnershipData = [
    {
      id: 1,
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" role="img" aria-label="Corporate partnerships icon">
          <path d="M4 13h6c0.55 0 1-0.45 1-1V4c0-0.55-0.45-1-1-1H4c-0.55 0-1 0.45-1 1v8c0 0.55 0.45 1 1 1zM4 21h6c0.55 0 1-0.45 1-1v-4c0-0.55-0.45-1-1-1H4c-0.55 0-1 0.45-1 1v4c0 0.55 0.45 1 1 1zM14 21h6c0.55 0 1-0.45 1-1v-8c0-0.55-0.45-1-1-1h-6c-0.55 0-1 0.45-1 1v8c0 0.55 0.45 1 1 1zM13 4v4c0 0.55 0.45 1 1 1h6c0.55 0 1-0.45 1-1V4c0-0.55-0.45-1-1-1h-6c-0.55 0-1 0.45-1 1z" />
        </svg>
      ),
      title: "Corporate Partners",
      description:
        "Partner with us to fulfill your corporate social responsibility goals while making a meaningful impact in communities. Together, we can create sustainable solutions that benefit both business objectives and social outcomes.",
    },
    {
      id: 2,
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" role="img" aria-label="NGOs and educational institutions icon">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
        </svg>
      ),
      title: "NGOs & Educational Institutions",
      description:
        "Collaborate on joint initiatives to leverage our combined resources and expertise for greater community impact. Through strategic alliances, we amplify our collective ability to address complex social challenges.",
    },
    {
      id: 3,
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" role="img" aria-label="Community volunteers icon">
          <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.75 1.75 0 0 0 18.3 7h-2.6c-.8 0-1.54.5-1.85 1.26l-1.92 5.77c-.24.71.12 1.48.8 1.77l2.27.97V22h4zM12.5 11.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S11 9.17 11 10s.67 1.5 1.5 1.5zM5.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm2.5 16v-7H6l-2.54-7.63A1.75 1.75 0 0 0 1.8 6H.5v2h1.3l1.8 5.4L2.5 15H8v7h2z" />
        </svg>
      ),
      title: "Community Volunteers",
      description:
        "Contribute your skills and time to support our programs and help us expand our reach to more communities. Your expertise and passion are invaluable in creating lasting positive change at the grassroots level.",
    },
  ];

  const handleGetInTouch = () => {
    // Navigate to contact section
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="partnerships-container" id="partnerships">
      <div className="partnerships-wrapper">
        <div className="partnerships-section">
          <div className="section-header">
            <h2
              className="partnership-section-title"
              style={{ color: "var(--primary)" }}
            >
              Strategic Partnerships
            </h2>
            <p className="section-subtitle">
              Building meaningful collaborations that drive community impact and
              sustainable development through shared vision and expertise.
            </p>
          </div>

          <div className="partnerships-grid">
            {partnershipData.map((partnership, index) => (
              <div
                key={partnership.id}
                className="partnership-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="card-icon">{partnership.icon}</div>
                <h3 className="partner-card-title">{partnership.title}</h3>
                <p className="partner-card-description">
                  {partnership.description}
                </p>
              </div>
            ))}
          </div>

          <div className="cta-section">
            <h3 className="cta-title">Ready to Make an Impact Together?</h3>
            <p className="cta-description">
              We welcome partnerships with organizations that share our vision
              for community empowerment and sustainable development. Let's
              explore how we can collaborate to create meaningful change.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <button onClick={handleGetInTouch} className="submit-btn">
                <span className="btn-text">Send Message</span>
                <svg
                  className="btn-icon"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partnerships;
